/* Skeleton Studio — native Shopify forms enhanced progressively. */
(() => {
  'use strict';
  if (window.SkeletonStudio) return;
  const configNode = document.getElementById('StudioConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const strings = config.strings;
  const features = config.features || {};
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const rootStyle = getComputedStyle(document.documentElement);
  const motionMs = () => reduced.matches ? 0 : Math.max(180, parseInt(rootStyle.getPropertyValue('--motion-global')) || 500);
  const nextFrame = callback => requestAnimationFrame(() => requestAnimationFrame(callback));
  const controllers = new WeakSet();
  const slideshows = new Map();
  const productGalleries = new Map();
  const yzyHomes = new Map();
  const dialogTimers = new WeakMap();
  const headerLifetimes = new Map();
  const dialogTriggers = new WeakMap();
  let cartQueue = Promise.resolve();
  let searchController;
  let searchTimer;
  let quickController;
  let headerMetricObserver;
  let headerMetricTarget;
  const zoomState = { items: [], index: 0 };
  function announce(message) { const node = $('[data-global-status]'); if (node) node.textContent = message; }
  function showError(node, message) { if (node) { node.hidden = false; node.textContent = message; } }
  function clearError(node) { if (node) { node.hidden = true; node.textContent = ''; } }
  async function request(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    const body = await response.json();
    if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : (typeof body.message === 'string' ? body.message : strings.error));
    return body;
  }
  function endpoint(url) { return url.endsWith('.js') ? url : `${url}.js`; }
  function finalizeDialog(dialog) {
    if (!dialog) return;
    clearTimeout(dialogTimers.get(dialog));
    if (!dialog.open) return;
    dialog.classList.remove('is-active', 'is-closing');
    dialog.close();
  }
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    $$('dialog[open]').forEach(other => { if (other !== dialog) finalizeDialog(other); });
    $$('.mega-nav[open]').forEach(menu => menu.open = false);
    if (!trigger && !dialog.open) trigger = document.activeElement;
    if (trigger) {
      dialogTriggers.set(dialog, trigger);
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('is-open');
    }
    clearTimeout(dialogTimers.get(dialog));
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    nextFrame(() => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      dialog.classList.add('is-active');
      if (id === 'SearchDialog') $('#SearchInput', dialog)?.focus();
    });
    return true;
  }
  function closeDialog(dialog) {
    if (!dialog?.open || dialog.classList.contains('is-closing')) return;
    if (reduced.matches || !document.body.classList.contains('motion-enabled')) { finalizeDialog(dialog); return; }
    dialog.classList.add('is-closing');
    dialog.classList.remove('is-active');
    dialogTimers.set(dialog, window.setTimeout(() => finalizeDialog(dialog), 300));
  }
  function renderZoom(index) {
    const dialog = $('#ZoomDialog');
    const image = dialog && $('[data-zoom-image]', dialog);
    if (!dialog || !image || !zoomState.items.length) return;
    zoomState.index = (index + zoomState.items.length) % zoomState.items.length;
    const link = zoomState.items[zoomState.index];
    image.src = link.href;
    image.alt = $('img', link)?.alt || '';
  }
  function openZoom(trigger) {
    const gallery = trigger.closest('[data-product-gallery]');
    zoomState.items = gallery ? $$('[data-zoom]', gallery) : [trigger];
    zoomState.index = Math.max(0, zoomState.items.indexOf(trigger));
    renderZoom(zoomState.index);
    openDialog('ZoomDialog', trigger);
  }
  function initDialogs(scope) {
    $$('dialog', scope).forEach(dialog => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
      });
      dialog.addEventListener('close', () => {
        if (dialog.open) return;
        clearTimeout(dialogTimers.get(dialog));
        dialog.classList.remove('is-active', 'is-closing');
        const trigger = dialogTriggers.get(dialog);
        if (trigger?.isConnected) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.remove('is-open');
          if (!document.querySelector('dialog[open]')) {
            const triggerHost = trigger.closest('dialog');
            const focusTarget = triggerHost && !triggerHost.open ? dialogTriggers.get(triggerHost) : trigger;
            if (focusTarget?.isConnected && !focusTarget.disabled) focusTarget.focus({ preventScroll: true });
            else $$('[data-open]').find(node => node.dataset.open === dialog.id && !node.closest('dialog'))?.focus({ preventScroll: true });
          }
        }
        if (dialog.hasAttribute('data-promotion')) {
          try { sessionStorage.setItem(`studio-promo-${dialog.dataset.promotionKey}`, 'dismissed'); } catch (_) { /* Storage may be disabled. */ }
        }
      });
    });
  }
  function renderCartSections(sections) {
    if (!sections || typeof sections['cart-drawer'] !== 'string') throw new Error(strings.error);
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const content = $('[data-cart-content]', doc);
    if (!content) throw new Error(strings.error);
    $('[data-cart-slot]')?.replaceChildren(content.cloneNode(true));
    const pageCart = $('.cart-page [data-cart-content]');
    if (pageCart && typeof sections.cart === 'string') {
      const pageDoc = new DOMParser().parseFromString(sections.cart, 'text/html');
      const pageContent = $('[data-cart-content]', pageDoc);
      if (pageContent) pageCart.replaceWith(pageContent);
    }
    $$('[data-cart-count]').forEach(node => {
      const next = content.dataset.count || '0';
      if (node.textContent !== next) { node.textContent = next; node.classList.remove('is-counting'); void node.offsetWidth; node.classList.add('is-counting'); }
    });
    $$('[data-cart-line]', $('[data-cart-slot]')).forEach((line, index) => { line.classList.add('is-new'); line.style.animationDelay = `${Math.min(index * 35, 140)}ms`; });
    announce(strings.cartUpdated);
  }
  async function refreshCart() {
    const url = new URL(config.cart, location.origin);
    url.searchParams.set('sections', 'cart-drawer,cart');
    const sections = await request(url.toString());
    renderCartSections(sections);
  }
  function queueCart(task) {
    const run = cartQueue.catch(() => {}).then(task);
    cartQueue = run.catch(() => {});
    return run;
  }
  async function changeCart(key, quantity, trigger) {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const dialogOpen = $('#CartDrawer')?.open;
    const error = dialogOpen ? $('#CartDrawer [data-cart-error]') : $('.cart-page [data-cart-error]');
    clearError(error);
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    $$('[data-cart-change], [data-cart-quantity]').forEach(node => { if ('disabled' in node) node.disabled = true; });
    try {
      await queueCart(async () => {
        const result = await request(endpoint(config.cartChange), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer', 'cart'], sections_url: config.cart })
        });
        try { renderCartSections(result.sections); } catch (_) { await refreshCart(); }
      });
      const area = dialogOpen ? $('#CartDrawer') : $('.cart-page');
      const replacement = $$('[data-cart-line]', area).find(node => node.dataset.cartLine === key);
      const nextFocus = replacement ? $('[data-cart-quantity]', replacement) : $('[data-close], a, button', area);
      nextFocus?.focus();
    } catch (errorValue) { showError(error, errorValue.message); }
    finally {
      trigger?.removeAttribute('aria-busy');
      $$('[data-cart-change], [data-cart-quantity]').forEach(node => { if ('disabled' in node) node.disabled = false; });
    }
  }
  function syncOptionAvailability(controller, variants, fields, selected) {
    fields.forEach((field, fieldIndex) => {
      $$('input[type=radio]', field).forEach(input => {
        const candidate = selected.slice();
        candidate[fieldIndex] = input.value;
        const available = variants.some(variant => variant.available && variant.options.every((value, index) => candidate[index] === undefined || candidate[index] === value));
        input.disabled = false;
        input.parentElement.dataset.unavailable = String(!available);
        input.setAttribute('aria-label', available ? input.value : `${input.value} — ${strings.soldOut}`);
        const state = $('[data-option-state]', input.parentElement);
        if (state) state.textContent = available ? '' : ` ${strings.soldOut}`;
      });
    });
  }

  function updateVariant(controller, options = { updateHistory: false }) {
    const variants = controller._variants;
    const fields = $$('[data-option-position]', controller);
    const selected = fields.map(field => $$('input', field).find(input => input.checked)?.value);
    fields.forEach((field, i) => { const label = $('[data-option-label]', field); if (label) label.textContent = selected[i] ? `: ${selected[i]}` : ''; });
    syncOptionAvailability(controller, variants, fields, selected);
    const select = $('[data-variant-select]', controller);
    const variant = fields.length ? variants.find(v => v.options.every((value, i) => value === selected[i])) : variants.find(v => String(v.id) === select.value);
    const button = $('[data-add-button]', controller);
    const host = controller.closest('[data-product-section], [data-quick-product]');
    const price = host && $('[data-product-price]', host);
    const stock = $('[data-stock]', controller);
    const accelerated = $('.shopify-payment-button', controller);
    if (accelerated) accelerated.hidden = !variant?.available;
    if (!variant) {
      button.disabled = true; button.textContent = selected.some(value => value === undefined) ? strings.selectOptions : strings.unavailable;
      if (stock) stock.textContent = selected.some(value => value === undefined) ? '' : strings.unavailable;
      select.disabled = true;
      if (price) price.hidden = true;
      const savings = host && $('[data-product-savings]', host);
      if (savings) savings.hidden = true;
      if (options.updateHistory && controller.closest('[data-product-section]')) { const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url); }
      return null;
    }
    select.disabled = false;
    select.value = String(variant.id);
    button.disabled = !variant.available;
    button.textContent = variant.available ? strings.add : strings.soldOut;
    if (stock) stock.textContent = variant.available ? strings.inStock : strings.soldOut;
    if (price) {
      price.hidden = false;
      price.classList.add('is-updating');
      // Prices are pre-formatted by Shopify Liquid for the active market.
      const current = document.createElement('span');
      current.className = 'price-current';
      current.textContent = variant.price;
      price.replaceChildren(current);
      if (variant.on_sale && features.comparePrice !== false) {
        const compare = document.createElement('s');
        compare.className = 'price-compare';
        compare.textContent = variant.compare;
        price.append(' ', compare);
      }
      requestAnimationFrame(() => price.classList.remove('is-updating'));
    }
    const savings = host && $('[data-product-savings]', host);
    if (savings) {
      if (variant.on_sale && variant.savings) { savings.hidden = false; savings.textContent = `SAVE ${variant.savings}`; }
      else { savings.hidden = true; savings.textContent = ''; }
    }
    const quantity = $('[name="quantity"]', controller);
    const rule = variant.quantity_rule || {};
    quantity.min = rule.min || 1; quantity.step = rule.increment || 1;
    if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
    if (Number(quantity.value) < Number(quantity.min) || (Number(quantity.value) - Number(quantity.min)) % Number(quantity.step)) quantity.value = quantity.min;
    if (rule.max && Number(quantity.value) > rule.max) quantity.value = rule.max;
    if (options.updateHistory && controller.closest('[data-product-section]')) {
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); url.searchParams.delete('option_values'); history.replaceState({}, '', url);
    }
    if (options.updateHistory && variant.media_id && host) {
      const media = $$('[data-media-id]', host).find(el => el.dataset.mediaId === String(variant.media_id));
      if (media) {
        const gallery = media.parentElement;
        if (window.matchMedia('(max-width:749px)').matches) gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth' });
        else media.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
      }
    }
    return variant;
  }
  function initProducts(scope) {
    $$('[data-product-controller]', scope).forEach(controller => {
      if (controllers.has(controller)) return;
      const data = $('[data-variant-data]', controller);
      if (!data) return;
      controller._variants = JSON.parse(data.textContent);
      controllers.add(controller);
      // Keep the complete native select as the no-JS fallback.
      const options = $('.variant-options', controller);
      if (options) { options.hidden = false; $('.variant-fallback', controller).hidden = true; if (controller.dataset.requireSelection === 'true') $$('input[type=radio]', options).forEach(input => input.checked = false); }
      updateVariant(controller);
      controller.addEventListener('change', async event => {
        if (!event.target.matches('.option-value input')) return;
        controller._request?.abort();
        controller.dataset.requireSelection = 'false';
        const match = updateVariant(controller, { updateHistory: true });
        // Shopify can expose more than 250 variants. Resolve missing combinations server-side.
        if (!match && controller._variants.length >= 250) {
          const ids = $$('[data-option-position] input:checked', controller).map(input => input.dataset.optionValueId);
          if (ids.some(id => !id)) return;
          const url = new URL(controller.dataset.productUrl, location.origin);
          url.searchParams.set('option_values', ids.join(','));
          url.searchParams.set('section_id', controller.dataset.sectionId);
          controller._request?.abort(); controller._request = new AbortController();
          try {
            const response = await fetch(url, { signal: controller._request.signal });
            if (!response.ok) throw new Error(strings.error);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const replacement = $('[data-product-controller]', doc);
            if (replacement) { controller.replaceWith(replacement); initProducts(replacement.parentElement); updateVariant(replacement, { updateHistory: true }); }
          } catch (err) { if (err.name !== 'AbortError') showError($('[data-product-error]', controller), err.message); }
        }
      });
    });
  }
  async function addProduct(form) {
    const controller = form.closest('[data-product-controller]');
    const button = $('[data-add-button]', form);
    if (button.disabled || form.dataset.submitting === 'true') return;
    const errorNode = $('[data-product-error]', form);
    clearError(errorNode);
    const body = new FormData(form);
    body.set('sections', 'cart-drawer,cart'); body.set('sections_url', config.cart);
    form.dataset.submitting = 'true'; button.disabled = true; button.textContent = strings.adding;
    try {
      await queueCart(async () => {
        const result = await request(endpoint(config.cartAdd), { method: 'POST', headers: { Accept: 'application/json' }, body });
        try { renderCartSections(result.sections); }
        catch (_) {
          // The add already succeeded. Never repeat it after a rendering/network error.
          try { await refreshCart(); } catch (_) { location.assign(config.cart); return; }
        }
        button.textContent = `${strings.added} ✓`; button.classList.add('is-added');
        if (features.cartDrawer === false) location.assign(config.cart); else openDialog('CartDrawer', button); announce(strings.added);
      });
    } catch (err) { showError(errorNode, err.message); }
    finally {
      form.dataset.submitting = 'false';
      window.setTimeout(() => { button.classList.remove('is-added'); updateVariant(controller); }, reduced.matches ? 0 : 700);
    }
  }
  async function quickAdd(trigger) {
    quickController?.abort(); quickController = new AbortController();
    const slot = $('[data-quick-slot]'); slot.textContent = strings.loading;
    if (!openDialog('QuickAddDialog', trigger)) { location.assign(trigger.href); return; }
    const url = new URL(trigger.dataset.quickAdd, location.origin); url.searchParams.set('section_id', 'quick-product');
    try {
      const response = await fetch(url, { signal: quickController.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(strings.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = $('[data-quick-product]', doc);
      if (!content) throw new Error(strings.error);
      slot.replaceChildren(content); initProducts(slot);
    } catch (err) {
      if (err.name === 'AbortError') return;
      slot.replaceChildren(document.createTextNode(err.message));
      const link = document.createElement('a'); link.href = trigger.href; link.textContent = strings.add; link.className = 'button'; slot.append(link);
    }
  }
  async function predictive(input) {
    searchController?.abort(); searchController = new AbortController();
    const results = $('[data-predictive-results]');
    const term = input.value.trim();
    if (term.length < 2) {
      const helper = document.createElement('p');
      helper.className = 'search-helper';
      helper.textContent = strings.searchPrompt || '';
      results.replaceChildren(helper);
      return;
    }
    const url = new URL(config.predictive, location.origin);
    url.searchParams.set('q', term); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6'); url.searchParams.set('section_id', 'predictive-search');
    results.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: searchController.signal });
      if (!response.ok) throw new Error(strings.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const list = $('.predictive-list', doc);
      if (list && input.value.trim() === term) results.replaceChildren(list);
    } catch (err) { if (err.name !== 'AbortError') results.textContent = strings.error; }
    finally { results.removeAttribute('aria-busy'); }
  }
  function initSlides(scope) {
    $$('[data-slideshow]', scope).forEach(root => {
      if (slideshows.has(root)) return;
      const slides = $$('[data-slide]', root);
      let active = Math.max(0, slides.findIndex(slide => !slide.hidden));
      let paused = reduced.matches || root.dataset.autoplay !== 'true';
      let timer;
      function videoState() {
        slides.forEach((slide, index) => {
          $$('video', slide).forEach(video => {
            if (video.hasAttribute('data-responsive-video')) {
              const src = window.matchMedia('(max-width:749px)').matches ? video.dataset.mobile : video.dataset.desktop;
              if (!reduced.matches && video.getAttribute('src') !== src) video.src = src;
            }
            if (root.dataset.videoAutoplay !== 'false' && index === active && !reduced.matches && !document.hidden && root.isConnected) video.play().catch(() => {});
            else video.pause();
          });
        });
      }
      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; slide.classList.toggle('is-active', i === active); });
        $$('[data-slide-to]', root).forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
        videoState();
      }
      function schedule() { clearInterval(timer); if (!paused && !document.hidden && slides.length > 1) timer = setInterval(() => show(active + 1), Number(root.dataset.interval) || 6000); }
      root.addEventListener('click', event => {
        const dot = event.target.closest('[data-slide-to]');
        if (dot) { show(Number(dot.dataset.slideTo)); schedule(); }
        const pause = event.target.closest('[data-slideshow-pause]');
        if (pause) { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); pause.textContent = paused ? strings.play : strings.pause; schedule(); }
      });
      root.addEventListener('focusin', () => clearInterval(timer));
      root.addEventListener('focusout', schedule);
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', schedule);
      let touchStart;
      root.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - touchStart; if (Math.abs(delta) > 60 && slides.length > 1) { show(active + (delta < 0 ? 1 : -1)); schedule(); } }, { passive: true });
      slideshows.set(root, { show, refresh: () => { videoState(); schedule(); }, destroy: () => { clearInterval(timer); $$('video', root).forEach(video => video.pause()); } });
      show(active); schedule();
    });
  }
  function initProductGalleries(scope) {
    $$('[data-product-gallery]', scope).forEach(root => {
      if (productGalleries.has(root)) return;
      const track = $('[data-gallery-track]', root);
      const items = $$('[data-gallery-item]', root);
      const currentNode = $('[data-gallery-current]', root);
      if (!track || items.length < 2) return;
      let current = 0;
      let frame = 0;
      const isHorizontal = () => { const style = getComputedStyle(track); return window.matchMedia('(max-width:749px)').matches || (style.display.includes('flex') && style.flexDirection === 'row'); };
      const updateCount = () => { if (currentNode && currentNode.textContent !== String(current + 1)) { currentNode.classList.add('is-updating'); currentNode.textContent = String(current + 1); requestAnimationFrame(() => currentNode.classList.remove('is-updating')); } };
      const measure = () => {
        frame = 0;
        const horizontal = isHorizontal();
        const trackRect = track.getBoundingClientRect();
        const reference = horizontal ? trackRect.left + trackRect.width / 2 : window.innerHeight / 2;
        let bestIndex = current;
        let bestDistance = Infinity;
        items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const center = horizontal ? rect.left + rect.width / 2 : rect.top + rect.height / 2;
          const distance = Math.abs(center - reference);
          if (distance < bestDistance) { bestDistance = distance; bestIndex = index; }
        });
        current = bestIndex;
        updateCount();
      };
      const scheduleMeasure = () => { if (!frame) frame = requestAnimationFrame(measure); };
      const go = delta => {
        current = (current + delta + items.length) % items.length;
        const behavior = reduced.matches ? 'auto' : 'smooth';
        if (isHorizontal()) track.scrollTo({ left: items[current].offsetLeft - track.offsetLeft, behavior });
        else items[current].scrollIntoView({ behavior, block: 'start' });
        updateCount();
      };
      root.addEventListener('click', event => {
        if (event.target.closest('[data-gallery-prev]')) { event.preventDefault(); go(-1); }
        if (event.target.closest('[data-gallery-next]')) { event.preventDefault(); go(1); }
      });
      track.addEventListener('scroll', scheduleMeasure, { passive: true });
      window.addEventListener('scroll', scheduleMeasure, { passive: true });
      window.addEventListener('resize', scheduleMeasure);
      productGalleries.set(root, { destroy: () => { cancelAnimationFrame(frame); track.removeEventListener('scroll', scheduleMeasure); window.removeEventListener('scroll', scheduleMeasure); window.removeEventListener('resize', scheduleMeasure); } });
      measure();
    });
  }

  function flipGrid(root, mutate) {
    const cards = $$('.yzy-product:not([hidden]), .product-card:not([hidden])', root).filter(card => card.getClientRects().length);
    cards.forEach(card => card.getAnimations().forEach(animation => animation.cancel()));
    const before = cards.map(card => card.getBoundingClientRect());
    mutate();
    if (reduced.matches || document.body.dataset.gridAnimation !== 'true') return;
    cards.forEach((card, index) => {
      const after = card.getBoundingClientRect(), first = before[index];
      card.animate([{ transform: `translate(${first.left - after.left}px, ${first.top - after.top}px)` }, { transform: 'none' }], { duration: 240, easing: 'cubic-bezier(.22,1,.36,1)' });
    });
  }
  function positionGenderIndicator(root) {
    const group = $('.yzy-gender', root); const active = $('[data-yzy-tab][aria-pressed="true"]', root);
    if (!group || !active) return;
    const g = group.getBoundingClientRect(), a = active.getBoundingClientRect();
    group.style.setProperty('--gender-indicator-left', `${a.left - g.left}px`);
    group.style.setProperty('--gender-indicator-width', `${a.width}px`);
  }
  function initYzyHomes(scope) {
    $$('[data-yzy-home]', scope).forEach(root => {
      if (yzyHomes.has(root)) return;
      const lifetime = new AbortController();
      yzyHomes.set(root, lifetime);
      const tabs = $$('[data-yzy-tab]', root);
      const panels = $$('[data-yzy-panel]', root);
      const zoom = $('[data-yzy-grid-zoom]', root);
      let gender = '';
      const mobile = matchMedia('(max-width:749px)');
      const setGender = (nextGender, updateUrl = true) => {
        if (!['male', 'female'].includes(nextGender) || nextGender === gender) { positionGenderIndicator(root); return; }
        const oldPanel = panels.find(panel => !panel.hidden);
        const newPanel = panels.find(panel => panel.dataset.yzyPanel === nextGender);
        const commit = () => {
          tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.yzyTab === nextGender)));
          panels.forEach(panel => { panel.hidden = panel !== newPanel; panel.classList.remove('is-leaving'); });
          if (newPanel && !reduced.matches) { newPanel.classList.remove('is-entering'); void newPanel.offsetWidth; newPanel.classList.add('is-entering'); window.setTimeout(() => newPanel.classList.remove('is-entering'), 450); }
          gender = nextGender; root.dataset.gender = nextGender; positionGenderIndicator(root);
          if (updateUrl) { const url = new URL(location.href); url.searchParams.set('gender', nextGender); history.replaceState({}, '', url); }
        };
        commit();
      };
      const mobileMaximum = Math.max(3, Math.min(5, Number(root.dataset.mobileColumns) || 3));
      const setGridColumns = columns => {
        const next = Math.max(1, Math.min(mobile.matches ? mobileMaximum : 3, Number(columns) || 3));
        flipGrid(root, () => { root.dataset.gridColumns = String(next); root.style.setProperty('--catalog-columns', String(next)); });
        if (zoom) { zoom.removeAttribute('aria-disabled'); zoom.disabled = false; zoom.dataset.columns = String(next); zoom.setAttribute('aria-label', strings.gridColumns.replace('__COUNT__', String(next)));
          $$('img', root).forEach(img => img.sizes = `${Math.ceil(100 / next)}vw`); }
      };
      const queryGender = new URL(location.href).searchParams.get('gender');
      setGender(['male', 'female'].includes(queryGender) ? queryGender : (root.dataset.initialGender || 'male'), false);
      setGridColumns(mobile.matches ? mobileMaximum : root.dataset.desktopColumns || 3);
      root.addEventListener('click', event => {
        const tab = event.target.closest('[data-yzy-tab]');
        if (tab) { event.preventDefault(); setGender(tab.dataset.yzyTab); return; }
        const gridZoom = event.target.closest('[data-yzy-grid-zoom]');
        if (gridZoom) { event.preventDefault(); setGridColumns(Number(root.dataset.gridColumns) > 1 ? Number(root.dataset.gridColumns) - 1 : mobile.matches ? mobileMaximum : 3); }
      }, { signal: lifetime.signal });
      mobile.addEventListener('change', () => setGridColumns(mobile.matches ? mobileMaximum : 3), { signal: lifetime.signal });
      window.addEventListener('resize', () => positionGenderIndicator(root), { passive: true, signal: lifetime.signal });
    });
  }

  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(root => {
      if (root.dataset.loaded) return;
      root.dataset.loaded = 'true';
      const observer = new IntersectionObserver(async entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        try {
          const response = await fetch(root.dataset.url);
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = $('[data-recommendations]', doc);
          if (content) { root.replaceChildren(...content.childNodes); initCardImages(root); }
        } catch (_) { /* Optional recommendations must not block shopping. */ }
      }, { rootMargin: '300px' });
      observer.observe(root);
    });
  }
  function initPromotions(scope) {
    $$('[data-promotion]', scope).forEach(dialog => {
      if (dialog.dataset.scheduled) return;
      dialog.dataset.scheduled = 'true';
      if (window.Shopify?.designMode) return;
      if (dialog.querySelector('[data-newsletter-result]')) { openDialog(dialog.id); return; }
      if (dialog.dataset.mobile === 'false' && matchMedia('(max-width:749px)').matches) return;
      try { if (sessionStorage.getItem(`studio-promo-${dialog.dataset.promotionKey}`)) return; } catch (_) {}
      setTimeout(() => { if (dialog.isConnected && !document.querySelector('dialog[open]')) openDialog(dialog.id); }, Number(dialog.dataset.delay) || 6000);
    });
    $$('[data-countdown]', scope).forEach(node => {
      if (node.dataset.bound) return;
      node.dataset.bound = 'true';
      const end = Date.parse(node.dataset.countdown);
      if (!Number.isFinite(end)) {
        const wrap = node.closest('[data-countdown-wrap]');
        if (wrap) wrap.hidden = true; else node.hidden = true;
        return;
      }
      const unitNodes = [
        { node: $('[data-countdown-days]', node), show: node.dataset.showDays !== 'false', label: 'D' },
        { node: $('[data-countdown-hours]', node), show: node.dataset.showHours !== 'false', label: 'H' },
        { node: $('[data-countdown-minutes]', node), show: node.dataset.showMinutes !== 'false', label: 'M' },
        { node: $('[data-countdown-seconds]', node), show: node.dataset.showSeconds !== 'false', label: 'S' }
      ];
      const structured = unitNodes.some(unit => unit.node);
      const update = () => {
        const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        if (structured) {
          const visible = unitNodes.map((unit, index) => unit.node && unit.show ? index : -1).filter(index => index >= 0);
          unitNodes.forEach((unit, index) => {
            if (!unit.node) return;
            unit.node.hidden = !unit.show;
            unit.node.textContent = `${String(values[index]).padStart(2, '0')}${unit.label}`;
            const separator = unit.node.nextElementSibling?.classList.contains('countdown-separator') ? unit.node.nextElementSibling : null;
            if (separator) separator.hidden = !unit.show || !visible.some(next => next > index);
          });
          node.hidden = visible.length === 0;
        } else {
          node.textContent = values.map(n => String(n).padStart(2, '0')).join(' : ');
        }
        return seconds;
      };
      if (update() > 0) {
        const timer = setInterval(() => { if (!node.isConnected || update() === 0) clearInterval(timer); }, 1000);
      }
    });
  }
  function initReveals(scope) {
    if (!document.body.classList.contains('motion-enabled')) return;
    const revealTargets = $$('[data-reveal], .product-card, .yzy-product', scope);
    revealTargets.forEach((node, index) => {
      if (node.dataset.revealBound) return; node.dataset.revealBound = 'true'; node.classList.add('reveal-ready');
      if (document.body.dataset.cardStagger === 'true' && (node.matches('.product-card,.yzy-product'))) node.style.transitionDelay = `${Math.min((index % 8) * 35, 175)}ms`;
    });
    if (document.body.dataset.scrollReveal === 'true' && 'IntersectionObserver' in window && !reduced.matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); } }), { rootMargin: '0px 0px -4% 0px', threshold: .04 });
      revealTargets.forEach(node => observer.observe(node));
    } else revealTargets.forEach(node => node.classList.add('is-revealed'));
  }
  function initCardImages(scope) {
    $$('.card-image--second, .yzy-product-image--second', scope).forEach(image => {
      if (image.dataset.secondaryBound) return;
      image.dataset.secondaryBound = 'true';
      const card = image.closest('.product-card, .yzy-product');
      const ready = () => card.classList.toggle('has-secondary-ready', image.complete && image.naturalWidth > 0);
      image.addEventListener('load', ready);
      image.addEventListener('error', () => card.classList.remove('has-secondary-ready'));
      ready();
    });
  }

  function initAccordions(scope) {
    if (document.body.dataset.accordionAnimation !== 'true' || reduced.matches) return;
    $$('details.product-accordion', scope).forEach(details => {
      if (details.dataset.animated) return; details.dataset.animated = 'true';
      const summary = $('summary', details); const content = summary?.nextElementSibling; if (!summary || !content) return;
      summary.addEventListener('click', event => {
        event.preventDefault(); if (details.classList.contains('accordion-animating')) return;
        const opening = !details.open; details.classList.add('accordion-animating');
        if (opening) details.open = true;
        const from = opening ? 0 : content.scrollHeight; const to = opening ? content.scrollHeight : 0;
        content.style.height = `${from}px`; content.style.opacity = opening ? '0' : '1'; content.style.transform = opening ? 'translateY(-4px)' : 'none'; content.style.overflow = 'hidden';
        requestAnimationFrame(() => { content.style.transition = `height var(--motion-ui) var(--ease-luxury),opacity var(--motion-ui) ease,transform var(--motion-ui) var(--ease-luxury)`; content.style.height = `${to}px`; content.style.opacity = opening ? '1' : '0'; content.style.transform = opening ? 'none' : 'translateY(-3px)'; });
        window.setTimeout(() => { if (!opening) details.open = false; content.removeAttribute('style'); details.classList.remove('accordion-animating'); }, 420);
      });
    });
  }
  function initHeaderMotion() {
    const header = $('[data-header]');
    if (!header || headerLifetimes.has(header)) return;
    const lifetime = new AbortController();
    let frame = 0;
    const update = () => { frame = 0; header.classList.toggle('is-compact', window.scrollY > 24); };
    window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true, signal: lifetime.signal });
    headerLifetimes.set(header, () => { lifetime.abort(); cancelAnimationFrame(frame); });
    update();
  }
  function initLayoutMetrics() {
    const group = $('.shopify-section-group-header-group');
    if (!group) return;
    const update = () => document.documentElement.style.setProperty('--header-stack-height', `${Math.ceil(group.getBoundingClientRect().height)}px`);
    update();
    if ('ResizeObserver' in window && group !== headerMetricTarget) {
      headerMetricObserver?.disconnect();
      headerMetricTarget = group;
      headerMetricObserver = new ResizeObserver(update);
      headerMetricObserver.observe(group);
    }
  }
  function init(scope = document) { initLayoutMetrics(); initCardImages(scope); initDialogs(scope); initProducts(scope); initSlides(scope); initProductGalleries(scope); initYzyHomes(scope); initRecommendations(scope); initPromotions(scope); initAccordions(scope); initReveals(scope); initHeaderMotion(); requestAnimationFrame(() => document.body.classList.add('is-ready')); }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open]');
    if (opener) { if (openDialog(opener.dataset.open, opener)) event.preventDefault(); return; }
    const close = event.target.closest('[data-close]');
    if (close) { event.preventDefault(); closeDialog(close.closest('dialog')); return; }
    const quick = event.target.closest('[data-quick-add]');
    if (quick) { event.preventDefault(); quickAdd(quick); return; }
    const change = event.target.closest('[data-cart-change]');
    if (change) { event.preventDefault(); if (!change.hasAttribute('aria-busy')) changeCart(change.dataset.cartChange, Number(change.dataset.quantity), change); return; }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const input = $('input', step.parentElement);
      const increment = Number(input.step) || 1;
      input.value = Math.max(Number(input.min) || 1, Math.min(Number(input.max) || Infinity, (Number(input.value) || 1) + Number(step.dataset.quantityStep) * increment));
      input.classList.remove('is-changing'); void input.offsetWidth; input.classList.add('is-changing');
      input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    const grid = event.target.closest('[data-grid-columns]');
    if (grid) {
      const root = grid.closest('[data-collection]'); if (!root) return;
      flipGrid(root, () => root.style.setProperty('--columns', grid.dataset.gridColumns));
      $$('[data-grid-columns]', root).forEach(button => button.setAttribute('aria-pressed', String(button === grid))); return;
    }
    const zoomStep = event.target.closest('[data-zoom-step]');
    if (zoomStep) { event.preventDefault(); renderZoom(zoomState.index + Number(zoomStep.dataset.zoomStep)); return; }
    const zoom = event.target.closest('[data-zoom]');
    if (zoom) { event.preventDefault(); openZoom(zoom); return; }
    const dismiss = event.target.closest('[data-dismiss-announcement]');
    if (dismiss) { const announcement = dismiss.closest('[data-announcement]'); announcement.hidden = true; return; }
    if (!event.target.closest('.mega-nav')) $$('.mega-nav[open]').forEach(menu => menu.open = false);
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.mega-nav') && event.target.open) $$('.mega-nav[open]').forEach(menu => { if (menu !== event.target) menu.open = false; });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') $$('.mega-nav[open]').forEach(menu => { menu.open = false; $('summary', menu)?.focus(); });
    const zoomDialog = $('#ZoomDialog');
    if (zoomDialog?.open && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault();
      renderZoom(zoomState.index + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  document.addEventListener('submit', event => {
    if (features.ajaxAdd !== false && event.target.matches('[data-product-form]')) { event.preventDefault(); addProduct(event.target); }
  });
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('[data-cart-quantity]')) changeCart(target.dataset.cartQuantity, Number(target.value), target);
    if (target.matches('[data-cart-note]')) {
      const note = target.value;
      queueCart(() => request(endpoint(config.cartUpdate), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) })).catch(err => showError($('[data-cart-error]', target.closest('.cart-page,dialog')), err.message));
    }
    if (target.matches('[data-sort]')) target.form.requestSubmit();
  });
  document.addEventListener('input', event => {
    if (features.predictive !== false && event.target.matches('[data-predictive-input]')) { clearTimeout(searchTimer); searchController?.abort(); searchTimer = setTimeout(() => predictive(event.target), 250); }
  });
  document.addEventListener('visibilitychange', () => slideshows.forEach(show => show.refresh()));
  reduced.addEventListener('change', () => slideshows.forEach(show => show.refresh()));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    headerLifetimes.forEach((destroy, header) => { if (event.target.contains(header)) { destroy(); headerLifetimes.delete(header); } });
    yzyHomes.forEach((lifetime, root) => { if (event.target.contains(root)) { lifetime.abort(); yzyHomes.delete(root); } });
    $$('dialog[open]', event.target).forEach(finalizeDialog);
    $$('[data-product-controller]', event.target).forEach(controller => controller._request?.abort());
    slideshows.forEach((show, root) => { if (event.target.contains(root)) { show.destroy(); slideshows.delete(root); } });
    productGalleries.forEach((gallery, root) => { if (event.target.contains(root)) { gallery.destroy(); productGalleries.delete(root); } });
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-slide]');
    if (slide) { const root = slide.closest('[data-slideshow]'); slideshows.get(root)?.show($$('[data-slide]', root).indexOf(slide)); }
  });
  document.addEventListener('shopify:section:select', event => { const promo = $('[data-promotion]', event.target); if (promo) openDialog(promo.id); });
  window.SkeletonStudio = { init, refreshCart };
  init();
})();
